import { IBatchImport, IBatchImportRow } from '@okcargo-apps/shared-domain';
import { BatchImportResponse, BatchImportRowResponse } from '@okcargo/query-processor';

export function transformToIBatchImport(dto: BatchImportResponse): IBatchImport {
  return {
    id: dto.id,
    type: dto.type,

    startedAt: new Date(dto.startedAt),
    finishedAt: dto.finishedAt ? new Date(dto.finishedAt) : undefined,

    totalRows: dto.totalRows,
    successCount: dto.successCount,
    errorCount: dto.errorCount,

    errorCode: dto.errorCode,
    errorMessage: dto.errorMessage,

    checkedAt: dto.finishedAt ? new Date(dto.checkedAt) : undefined,
  };
}

export function transformToIBatchImportList(dtos: BatchImportResponse[]): IBatchImport[] {
  return (dtos ?? []).map((dto) => transformToIBatchImport(dto));
}

export function transformToIBatchImportRow(dto: BatchImportRowResponse): IBatchImportRow {
  return {
    id: dto.id,
    rowNumber: dto.rowNumber,
    status: dto.status,
    errorCode: dto.errorCode,
    errorMessage: dto.errorMessage,
    createdEntityId: dto.createdEntityId,
    originalRow: dto.originalRow,
  };
}

export function transformToIBatchImportRowList(dtos: BatchImportRowResponse[]): IBatchImportRow[] {
  return (dtos ?? []).map((dto) => transformToIBatchImportRow(dto));
}
